import { ORGANIZATION_TYPE } from "../consts/common";
import { ProductsCodeEnum, ProductsIdEnum } from "../consts/redesign/commonRedesign";

type CardInfoType = {
  title: string;
  description: string;
  weight: number;
}
export enum ProccessCardTypeEnum {
  Inner = "Inner",
  Outer = "Outer",
  Modal = "Modal",
}

export type ResponseItemDataType = {
  id: number;
  image: string;
  icon: string;
  views: number;
  likes: number;
  name: string;
  min_term: number | null;
  min_term_type: number | null;
  min_rate: number | null;
  max_term: number | null;
  max_term_type: number | null;
  max_rate: number | null;
  min_sum: number | null;
  max_sum: number | null;
  min_fee: number | null;
  max_fee: number | null;
  card_info: string[];
  cardInfo: CardInfoType[];
  headline: {
    tagId: number,
    name: string
  }[] | [];
  bankName: string;
  bankAlias: string;
  productAlias: string;
  proposalAlias: string;
  isIndividualProduct: boolean;
  proccessCardType: ProccessCardTypeEnum;
  reference: string;
  seoDescription: string;
  organizationType: string;
  price: number | null; //ежемесячный платеж
  liquidity: string | null;
  liquidityType: number | null; //0выс 1 ср 3 низк
  realProposalId: number;
}

export const TermTypeValue = ["дн", "мес", "лет"];

export type ResponseDataType = {
  result: ResponseItemDataType[],
  pagination: {
    offset: number,
    count: number,
    total: number,
  }
}

export type CardInfoTypes = {
  title: string;
  description: string;
}

export type RecommendedSubType = {
  id: number,
  bank: {
    id: number,
    name: string,
  },
  name: string,
  description: string,
  cardInfo: CardInfoTypes[]
}

export type RecommendedType = {
  id: number,
  name: string,
  order: number,
  proposals: RecommendedSubType[],
}

export type InnerProductDetailsInfo = {
  Text: string | string[],
  Title: string,
}
export type NameValueType = {
  Name: string;
  Value: InnerProductDetailsInfo[];
};
export type GetPropsQueryType = {
  count?: number,
  offset?: number,
  bankId?: number,
  product_id?: number,
  main_page?: boolean,
  isIndividual?: boolean,
}
export type InnerProductDetailsData = {
  Terms?: InnerProductDetailsInfo[],
  ProductsInfo?: NameValueType[],
  name: string,
  bankid: number,
  productname: string,
  bankname: string,
  tarifffilename: string,
  tarifffilesize: number,
  tariffurl: string,
  proposalid: number,
  view: number,
  fileid: number | null,
  seodescription: string | null,
  ProductDescription: string[] | null,
  organizationType: ORGANIZATION_TYPE,
  banklicense: string,
}

export type FiltersType = {
  productId: number,
  sumMin: number,
  sumMax: number,
  sumStep: number,
  srokMin: number,
  srokMax: number,
  srokStep: number,
  srokType: string,
  objectives: string[],
  purchaseType: string[],
  garantiaType: string[],
  factoringType: string[]
}

export type FilterParametersType = {
  SumMin?: number;
  SumMax?: number;
  Srok?: number;
  SrokType?: string;
  Banks?: number[];
  Objective?: string[];
  PurchaseType?: string[];
  GarantiaType?: string[];
  FactoringType?: string[];
  productType?: string;

  sort_type?: SortProposalsEnum;
  inn?: string;

  name?: string;
  // для старой реализации
  cost?: number[];
  time?: number;
  objective?: string;
  boughtType?: string;
  bgType?: string;
  factoringType?: string;
  city?: string;
};

export type FilterByProduct = {
  productType: keyof typeof ProductsIdEnum;
  filters: FilterParametersType
}

export enum SortProposalsEnum {
  bydefault = "bydefault",
  bysumdesc = "bysumdesc",
  bysumasc = "bysumasc",
  byratedesc = "byratedesc",
  byrateasc = "byrateasc",
  bysrokdesc = "bysrokdesc",
  bysrokasc = "bysrokasc",
  bypricedesc = "bypricedesc",
  bypriceasc = "bypriceasc",
  bypostponementdesc = "bypostponementdesc",
  bypostponementasc = "bypostponementasc",
  byfeedesc = "byfeedesc",
  byfeeasc = "byfeeasc",
  bybanknameasc = "bybanknameasc",
  bybanknamedsc = "bybanknamedsc"
}
export enum SortProposalsNames {
  bydefault = "по умолчанию",
  bysumdesc = "сумма по убыванию",
  bysumasc = "сумма по возрастанию",

  byratedesc = "ставка по убыванию",
  byrateasc = "ставка по возрастанию",

  bysrokdesc = "срок по убыванию",
  bysrokasc = "срок по возрастанию",

  bypricedesc = "платеж по убыванию",
  bypriceasc = "платеж по возрастанию",

  bypostponementdesc = "отсрочка по убыванию",
  bypostponementasc = "отсрочка по возрастанию",

  byfeedesc = "взнос по убыванию",
  byfeeasc = "взнос по возрастанию",

  bybanknameasc = "банк - а-я",
  bybanknamedsc = "банк - я-а"
}

export enum SortProposalsNamesForBG {
  bydefault = "по умолчанию",
  bysumdesc = "сумма по убыванию",
  bysumasc = "сумма по возрастанию",
  byratedesc = "ставка по убыванию",
  byrateasc = "ставка по возрастанию",
  bysrokdesc = "срок по убыванию",
  bysrokasc = "срок по возрастанию",
  bypricedesc = "стоимость гарантии по убыванию",
  bypriceasc = "стоимость гарантии по возрастанию",
  bybanknameasc = "банк - а-я",
  bybanknamedsc = "банк - я-а"
}

export enum TypeProposalsEnum {
  All = "All",
  Profitable = "Profitable",
  Popular = "Popular",
  Best = "Best",
  BestOfMonth = "BestOfMonth",
  Real = "Real",
  Recommended = "Recommended",
  Promoted = "Promoted",
  ForLK = "ForLK",
}

export enum InputCalculatorTypeEnum {
  input = "input",
  select = "selector",
}

export type OptionsType = {
  key: string;
  value: string;
};

export type GetPropsUniversalQueryType = {
  id?: number;
  count?: number;
  offset?: number;
  bankIds?: number[] | number | string;
  product_id?: number;
  main_page?: boolean;
  isIndividual?: boolean;
  sort_type?: SortProposalsEnum | string;
  Type?: TypeProposalsEnum;
  check?: string;

  inn?: string;
  isRealCard?: boolean;
  sumMin?: number;
  sumMax?: number;
  fee?: number;
  srok?: number;
  srokType?: string;
  objective?: string[];
  purchaseType?: string[];
  garantiaType?: string[];
  factoringType?: string[];
  name?: string;
};

export type ParameterForProposalCalculatorType = {
  value: number | string;
  name: string;
  suffix: string;
};

export type ProposalCalculatorBodyType = {
  proposalId: number;
  values: ParameterForProposalCalculatorType[];
};

export type ProposalCalculatorInputType = {
  type: InputCalculatorTypeEnum;
  default: number;
  max: number | null;
  min: number | null;
  step: number;
  suffix: string;
  options: OptionsType[] | null;
  name: string;
  description: string;
  weight: number;
};

export type ProposalCalculatorType = {
  title: string;
  parameters: ProposalCalculatorInputType[];
  resultDescription: string;
};

export type ProposalCompareTypeRes = {
  proposals: ProposalCompareType[];
};

export type ProposalCompareType = {
  proposalsId: number;
  productsInfo: [
    {
      name: string;
      value: [
        {
          text: [string];
          title: string;
        }
      ];
    }
  ];
  bankImage: string;
  bankImageV2: string;
  productAlias: ProductsCodeEnum;
  bankIcon: string;
  bankName: string;
  bankId: string;
};
